
  import { defineComponent, ref, toRefs, watch } from "vue";
  import { Contract } from "@/model/api/Contract";
  import {materialsService} from "@services/materials.service";

  export default defineComponent({
    name: "MaterialAutocomplete",

    inheritAttrs: false,
    emits: ['select'],
    props: [
      "modelValue",
      "forceSelection",
      "label",
      "noDropdown"
    ],

    setup(_, { emit }) {
      const { modelValue } = toRefs(_);

      const searchBox   = ref<string | Contract>("");
      const suggestions = ref(null);
      const selected    = ref(null);

      async function search({ query }) {

        const text = (query as string).toLowerCase().trim();

        suggestions.value = await materialsService.getAll({
          q: text
        });
      }

      async function onSelect({ value }) {
        selected.value = value;
        emit("select", value);
      }

      async function onClear() {
        searchBox.value = null
        emit("select", null);
      }

      watch(
        modelValue,
        () => {
          searchBox.value = modelValue.value;
        },
        {
          immediate: true,
        }
      );
      
      function selectedLabel(item: Contract) {
        return `${item.name}`;
      }

      return {
        searchBox,
        suggestions,
        onClear,
        onSelect,
        search,
        selectedLabel
      };
    },
  });
